import { render, staticRenderFns } from "./MarketFiles.vue?vue&type=template&id=4d7bacab&scoped=true&"
import script from "./MarketFiles.vue?vue&type=script&lang=js&"
export * from "./MarketFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7bacab",
  null
  
)

export default component.exports